import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AddressSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AddressSVG;
